<template>
    <!--弹窗-->
    <el-dialog
        width="80%"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
        top="5vh"
        append-to-body
    >
        <el-form ref="previewData" :model="previewData" :rules="rules" :inline="true" size="mini">
            <div class="subTitle">基础信息</div>
            <div class="top1">
                <div class="top1Left">
                    <el-form-item label="">
                        <img style="width:90px;height:90px;" :src="previewData.img_url" v-if="previewData.img_url"/>
                    </el-form-item>
                </div>
                <div class="top1Right">
                    <div class="itemInfo">
                        <div class="itemTitle">ID:</div>
                        <div class="itemContent">{{ previewData.id }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">ASIN:</div>
                        <div class="itemContent">
                            <icon-svg :icon-class="previewData.state.toUpperCase()"
                                      style="font-size: 24px;margin-right:5px;" v-if="previewData.state"></icon-svg>
                            {{ previewData.asin }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">类目:</div>
                        <div class="itemContent" @click="showInfo('类目', previewData.category)">{{
                                previewData.category
                            }}
                        </div>
                    </div>

                    <div class="itemInfo">
                        <div class="itemTitle">专利:</div>
                        <el-button type="success" :disabled="!previewData.patent_file"
                                   @click="downFile(previewData.patent_file)" size="mini">下载
                        </el-button>
                        <div class="itemContent">{{ previewData.patent_value }}</div>
                    </div>

                    <div class="itemInfo">
                        <div class="itemTitle">父ASIN:</div>
                        <div class="itemContent">{{ formData.parent_asin }}</div>
                    </div>

                    <div class="itemInfo">
                        <div class="itemTitle">品牌:</div>
                        <div class="itemContent" @click="showInfo('品牌', previewData.brand)">{{ previewData.brand }}
                        </div>
                    </div>

                    <div class="itemInfo">
                        <div class="itemTitle">评分:</div>
                        <div class="itemContent">{{ formData.rating }}</div>
                    </div>

                    <div class="itemInfo">
                        <div class="itemTitle">评论数:</div>
                        <div class="itemContent">{{ formData.rating_count }}</div>
                    </div>

                </div>
            </div>
            <hr>
            <div class="subTitle">调整参数</div>
            <div class="top2">
                <div class="line1">
                    <div class="itemInfo">
                        <div class="itemTitle">标题:</div>
                        <div class="itemContent" @click="showInfo('标题', previewData.title)">{{ previewData.title }}
                        </div>
                    </div>
                </div>
                <div class="line2">
                    <div class="itemInfo">
                        <div class="itemTitle">销售价格:</div>
                        <div class="itemContent">{{ previewData.selling_price }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">是否确认销售价格:</div>
                        <div class="itemContent">{{ previewData.confirm_selling_price == 1 ? '是' : '否' }}</div>
                    </div>

                    <div class="itemInfo">
                        <div class="itemTitle">是否季节性:</div>
                        <div class="itemContent">{{ previewData.is_seasonality == 1 ? '是' : '否' }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">季节:</div>
                        <div class="itemContent">{{ previewData.season }}</div>
                    </div>
                </div>
                <div class="line2">
                    <div class="itemInfo">
                        <div class="itemTitle">规格-长(cm):</div>
                        <div class="itemContent">{{ previewData.long }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">规格-宽(cm):</div>
                        <div class="itemContent">{{ previewData.wide }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">规格-高(cm):</div>
                        <div class="itemContent">{{ previewData.height }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">规格-重(g):</div>
                        <div class="itemContent">{{ previewData.weight }}</div>
                    </div>
                </div>
                <div class="line3">
                    <div class="itemInfo">
                        <div class="itemTitle">退货率:</div>
                        <div class="itemContent">{{ parseFloat((previewData.refund_rate || 0) * 100).toFixed(2) }}%</div>
                    </div>
                </div>
            </div>
            <hr>
            <div class="subTitle">1688产品</div>
            <div class="top3">
                <div class="top3Left">
                    <div v-if="!previewData.ali_pic_url">暂无图片</div>
                    <img style="width:90px;height:90px;" :src="previewData.ali_pic_url" v-if="previewData.ali_pic_url"/>
                </div>
                <div class="top3Right">
                    <div class="itemInfo">
                        <div class="itemTitle">图片路径:</div>
                        <div class="itemContent" @click="showInfo('图片路径', previewData.ali_pic_url)">{{
                                previewData.ali_pic_url
                            }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">标题:</div>
                        <div class="itemContent" @click="showInfo('标题', previewData.ali_title)">{{
                                previewData.ali_title
                            }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">产品价格:</div>
                        <div class="itemContent">{{ previewData.ali_factory_price }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">产品链接:</div>
                        <div class="itemContent" @click="showInfo('产品链接', previewData.ali_href_link)">{{
                                previewData.ali_href_link
                            }}
                        </div>
                        <el-button v-show="previewData.ali_href_link" type="primary" size="mini"
                                   @click="jumpUrl(previewData.ali_href_link)">跳转
                        </el-button>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle" style="width:150px;">是否确认1688链接:</div>
                        <div class="itemContent">{{ previewData.confirm_ali_message == 1 ? '是' : '否' }}</div>
                    </div>
                </div>
            </div>
            <hr>
            <div class="subTitle">成本结算</div>
            <div class="top4">
                <div class="line1">
                    <div class="itemInfo">
                        <div class="itemTitle">运费:</div>
                        <div class="itemContent">{{ previewData.freight }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">平台佣金:</div>
                        <div class="itemContent">{{ previewData.platform_commission }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">配送费:</div>
                        <div class="itemContent">{{ previewData.delivery_charge }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">退货费用:</div>
                        <div class="itemContent">{{ previewData.refund_charge }}</div>
                    </div>
                </div>
                <div class="line2">
                    <div class="itemInfo">
                        <div class="itemTitle">仓储费:</div>
                        <div class="itemContent">{{ previewData.storage_charge }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">利润:</div>
                        <div class="itemContent">{{
                                previewData.profit
                            }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">利润率:</div>
                        <div class="itemContent">
                            {{ formData['profit_rate'] ? accMul(formData['profit_rate'], 100) + '%' : '-' }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">投资回报率:</div>
                        <div class="itemContent">{{
                                previewData['investment_return_rate'] ?
                                    (accMul(previewData['investment_return_rate'], 100) + '%') : '-'
                            }}
                        </div>
                    </div>
                </div>
                <div class="line2">
                    <div class="itemInfo">
                        <div class="itemTitle">0利润销售价格:</div>
                        <div class="itemContent">{{ previewData.seller_price_no_profit }}</div>
                    </div>
                </div>
            </div>
            <hr>
            <div class="subTitle">额外信息</div>
            <div class="top4">
                <div class="line1">
                    <div class="itemInfo">
                        <div class="itemTitle">创建时间:</div>
                        <div class="itemContent">{{ formData.create_time }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">成本分析:</div>
                        <div class="itemContent">{{ getCostAnalysisTxt(previewData.status) }}</div>
                    </div>
                    <div class="itemInfo itemInfoRemark">
                        <div class="itemTitle">备注:</div>
                        <div class="itemContent" style="max-width: 500px; width: 500px;">{{ formData.remark }}</div>
                    </div>

                </div>
                <div class="line1">
                    <div class="itemInfo">
                        <div class="itemTitle">采购状态:</div>
                        <div class="itemContent">
                            {{
                                previewData.purchase_status == 0 ? '选品中' : previewData.purchase_status == 1 ? '采购中' :
                                    '采购完成'
                            }}
                        </div>
                    </div>

                    <div class="itemInfo">
                        <div class="itemTitle">采购人员:</div>
                        <div class="itemContent">
                            {{ formData.developer_username }}
                            <span v-show="formData.developer_full_name">（{{ formData.developer_full_name }}）</span>
                        </div>
                    </div>

                    <div class="itemInfo">
                        <div class="itemTitle">分配采购时间:</div>
                        <div class="itemContent">
                            {{ formData.assign_developer_time }}
                        </div>
                    </div>

                    <div class="itemInfo">
                        <div class="itemTitle">采购完成时间:</div>
                        <div class="itemContent">{{ formData.assign_developer_finish_time }}</div>
                    </div>
                </div>
                <div class="line1">
                    <div class="itemInfo">
                        <div class="itemTitle">运营状态:</div>
                        <div class="itemContent">
                            {{
                                previewData.operation_status == 0 ? '待运营' : previewData.operation_status == 1 ? '运营中' :
                                    '不再运营'
                            }}
                        </div>
                    </div>

                    <div class="itemInfo">
                        <div class="itemTitle">运营人员:</div>
                        <div class="itemContent">
                            {{ formData.operation_username }}
                            <span v-show="formData.operation_full_name">（{{ formData.operation_full_name }}）</span>
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">分配运营时间:</div>
                        <div class="itemContent">{{ formData.assign_operation_time }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">开始运营时间 :</div>
                        <div class="itemContent">{{ previewData.operation_running_time }}</div>
                    </div>
                </div>
                <div class="line1">
                    <div class="itemInfo">
                        <div class="itemTitle">运营asin数量 :</div>
                        <div class="itemContent">{{ previewData.operator_asin_count }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">不再运营时间 :</div>
                        <div class="itemContent">{{ previewData.operation_fail_time }}</div>
                    </div>
                </div>
            </div>


        </el-form>
        <!--        <categoryList :visible="showCategoryList" @choose1688Info="choose1688Info" :copyData="copyData"-->
        <!--                      @close-callback="showCategoryList=false"></categoryList>-->
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose()"
            >关 闭
            </el-button>
            <!--            <el-button style="float:right" size="mini" type="primary" @click="submitForm()" :loading="loading" v-if="funcType == 1">修 改-->
            <!--            </el-button>-->
        </el-row>
        <child-info-modal :visible="childInfoVisible" :info="previewInfo"
                          @close-callback="closeCllback"></child-info-modal>
    </el-dialog>
</template>
<script>
import * as api from '@/api/advAnalys/advAnalys.js'
import categoryList from './categoryList'
import childInfoModal from './childInfoModal.vue'
import {downloadFileUrl} from '@/utils/method'

export default {
    components: {categoryList, childInfoModal},
    data() {
        return {
            flagType: 0,
            funcType: 0,
            loading: false,
            showCategoryList: false,
            options: [],
            copyData: {},
            title: '',
            visible: false,
            rules: {
                keepa_category_id: [
                    {
                        required: true,
                        message: '请选择根类目',
                        trigger: 'blur'
                    },
                ],
            },
            previewData: {},
            previewInfo: {},
            formData: {},
            childInfoVisible: false,
        }
    },
    watch: {
        visible: {
            handler(flag) {
                if (flag) {
                    const tempData = JSON.parse(JSON.stringify(this.formData))
                    // tempData.wrappage_long = tempData.long
                    // tempData.wrappage_wide = tempData.wide
                    // tempData.wrappage_height = tempData.height
                    // tempData.wrappage_weight = tempData.weight

                    // tempData.refund_rate = this.accMul(tempData.refund_rate, 100)
                    // tempData.is_seasonality = tempData.is_seasonality === 1 ? true : false
                    this.previewData = tempData
                }
            },
            immediate: true,
            deep: true
        },
    },

    methods: {
        // 获取成本分析字符串
        getCostAnalysisTxt(num) {
            let txt = '分析中'
            switch (num) {
                case 0:
                    txt = '待分析'
                    break
                case -1:
                    txt = '分析失败'
                    break
                case 2:
                    txt = '分析完成'
                    break
                default:
                    txt = '分析中'
            }
            return txt
        },
        downFile(path) {
            if (!path) {
                return this.$message({
                    type: 'error',
                    message: '无法下载！'
                })
            }
            downloadFileUrl(path)
        },
        // 关闭弹窗回调
        closeCllback(isShow) {
            this.childInfoVisible = false
            this.previewInfo = {}
            isShow == true && this.getList()
        },
        showInfo(title, info) {
            console.log('==')
            this.previewInfo = {title, info}
            this.childInfoVisible = true
        },
        jumpUrl(url) {
            window.open(url, '_blank')
        },
        choose1688Info(data) {
            this.previewData.ali_href_link = data.detail_url
            this.previewData.ali_factory_price = data.price
            this.previewData.ali_title = data.title
            this.previewData.ali_pic_url = data.pic_url
            this.showCategoryList = false
        },
        choose1688() {
            this.showCategoryList = true
        },
        // 保存信息
        submitForm() {
            this.$refs['previewData'].validate(valid => {
                if (valid) {
                    api.cost_analysis_personal_update_field({
                        id: this.previewData.id,
                        wrappage: this.previewData.wrappage,
                        wrappage_long: this.previewData.wrappage_long,
                        wrappage_wide: this.previewData.wrappage_wide,
                        wrappage_height: this.previewData.wrappage_height,
                        wrappage_link: this.previewData.wrappage_link,
                        purchase_specification_remark: this.previewData.purchase_specification_remark,
                    }).then(res => {
                        this.loading = false
                        if (res.code === 0) {
                            this.$message({
                                message: '修改成功',
                                type: 'success'
                            })
                            this.handleClose(true)
                        } else {
                            this.$message({type: 'error', message: res.message})
                        }
                    }).catch(() => {
                        this.loading = false
                        this.$message({
                            type: 'error',
                            message: '网络出现问题，请刷新页面！'
                        })
                    })
                } else {
                    this.loading = false
                    this.$message({
                        type: 'error',
                        message: '请填写相应内容！'
                    })
                }
            })
        },
        // 关闭弹窗
        handleClose(isshow = false) {
            this.previewData = {}
            this.$refs['previewData'].resetFields()
            this.loading = false
            this.visible = false
            this.$emit('close-callback', isshow)
        },
        // 重置
        handleReset(isshow = false) {
            api.cost_analysis_personal_reset({id: this.previewData.id,}).then(res => {
                if (res.code === 0) {
                    this.$message({message: '重置成功', type: 'success'})

                    const tempVal = JSON.parse(JSON.stringify(res.data))
                    tempVal.refund_rate = this.accMul(tempVal.refund_rate, 100)
                    tempVal.is_seasonality = tempVal.is_seasonality === 1 ? true : false
                    this.$set(this, 'previewData', tempVal)

                    this.$emit('refreshList')
                } else {
                    this.$message({type: 'error', message: res.message})
                }
            }).catch(() => {
                this.$message({
                    type: 'error',
                    message: '网络出现问题，请刷新页面！'
                })
            })
        },
        /**
         * 数字相加
         * @param {*} arg1
         * @param {*} arg2
         * @returns
         */
        accAdd(arg1, arg2) {
            return this.changeNum(arg1, arg2)
        },

        /**
         * 数字相乘
         * @param {*} arg1
         * @param {*} arg2
         * @returns
         */
        accMul(arg1, arg2) {
            let m = 0
            m = this.accAdd(m, this.getDecimalLength(arg1))
            m = this.accAdd(m, this.getDecimalLength(arg2))
            return this.getNum(arg1) * this.getNum(arg2) / Math.pow(10, m)
        },

        accDiv(arg1, arg2) {
            let t1, t2
            t1 = this.getDecimalLength(arg1)
            t2 = this.getDecimalLength(arg2)
            if (t1 - t2 > 0) {
                return (this.getNum(arg1) / this.getNum(arg2)) / Math.pow(10, t1 - t2)
            } else {
                return (this.getNum(arg1) / this.getNum(arg2)) * Math.pow(10, t2 - t1)
            }
        },

        changeNum(arg1 = '', arg2 = '', isAdd = true) {
            const changeInteger = (arg, r, maxR) => {
                if (r != maxR) {
                    let addZero = ''
                    for (let i = 0; i < maxR - r; i++) {
                        addZero += '0'
                    }
                    arg = Number(arg.toString().replace('.', '') + addZero)
                } else {
                    arg = this.getNum(arg)
                }
                return arg
            }

            let r1, r2, maxR, m
            r1 = this.getDecimalLength(arg1)
            r2 = this.getDecimalLength(arg2)
            maxR = Math.max(r1, r2)
            arg1 = changeInteger(arg1, r1, maxR)
            arg2 = changeInteger(arg2, r2, maxR)
            m = Math.pow(10, maxR)
            if (isAdd) {
                return (arg1 + arg2) / m
            } else {
                return (arg1 - arg2) / m
            }
        },

        getDecimalLength(arg = '') {
            try {
                return arg.toString().split('.')[1].length
            } catch (e) {
                return 0
            }
        },

        getNum(arg = '') {
            return Number(arg.toString().replace('.', ''))
        },
    }
}
</script>
<style type="text/scss" lang="scss" scoped>
.subTitle {
    font-size: 16px;
    font-weight: 900;
    margin: 20px 0;
}

.top1 {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .top1Right {
        display: flex;
        flex-wrap: wrap;
        width: 1200px;

        .itemInfo {
            width: 360px;
            display: flex;
            height: 28px;
            line-height: 28px;

            .itemTitle {
                font-size: 14px;
                color: #606266;
                padding: 0 10px 0 0;
                font-weight: 900;
            }

            .itemContent {
                width: 230px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }
}

.top2 {
    .line1 {
        .itemInfo {
            width: 100%;
        }

        .itemContent {
            width: calc(100% - 100px);
        }
    }

    .line2, .line3 {
        width: 900px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .itemInfo {
            width: 240px;
        }

        .itemContent {
            width: 100px;
        }

        .itemTit {
            height: 28px;
            line-height: 28px;
            font-size: 14px;
            color: #606266;
            padding: 0 12px 0 0;
            font-weight: 900;
        }
    }

    .line2 {
        width: 1200px;
    }

    .itemInfo {
        display: flex;
        justify-content: start;
        height: 28px;
        line-height: 28px;

        .itemTitle {
            font-size: 14px;
            color: #606266;
            padding: 0 10px 0 0;
            font-weight: 900;
        }

        .itemContent {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
}

.top3 {
    display: flex;
    justify-content: space-between;
    width: 600px;

    .top3Left {
        width: 100px;
        height: 120px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;

        button {
            margin-top: 10px;
        }
    }

    .top3Right {
        width: 400px;

        .itemInfo {
            width: 360px;
            display: flex;
            height: 28px;
            line-height: 28px;

            .itemTitle {
                font-size: 14px;
                color: #606266;
                padding: 0 10px 0 0;
                font-weight: 900;
            }

            .itemContent {
                width: 230px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }
}

.top4 {
    .line1, .line2, .line4, .line3 {
        display: flex;
        justify-content: start;
    }

    .itemInfo {
        width: 25%;
        display: flex;
        height: 28px;
        line-height: 28px;
        margin-bottom: 10px;

        .itemTitle {
            font-size: 14px;
            color: #606266;
            padding: 0 10px 0 0;
            font-weight: 900;
        }

        .itemContent {
            max-width: 230px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    .itemInfoRemark {
        width: 50%;
    }

    .line4 {
        .line4Left, .line4Right {
            width: 50%;
        }

        .itemInfo {
            width: 100%;
        }
    }

}

.content {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #cecfd1;
    font-size: 12px;
    color: #000;

    .shu {
        border-right: 1px solid #cecfd1;
    }

    .content-div {
        width: 50%;
        padding: 25px 20px;
    }

    .content-buttom {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #cecfd1;
        padding-bottom: 8px;
        margin-bottom: 10px;
    }

    .content-buttom-txet {
        color: rgb(57, 187, 252);
        cursor: pointer;
    }

    .content-data {
        width: 100%;
        height: 230px;
        overflow: auto;

        .content-list {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 10px 0;

            .cha {
                cursor: pointer;
                font-size: 15px;
                color: rgb(158, 192, 209);
                margin: 0 10px 0 12px;
            }
        }
    }

    /deep/ .content-data::-webkit-scrollbar {
        width: 3px;
        height: 5px;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-track-piece {
        background-color: #ffff;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-thumb:vertical {
        height: 5px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-thumb:horizontal {
        width: 3px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
}

.media-txt {
    font-size: 15px;
    color: #6a6c6f;
    font-weight: 600;
    margin-bottom: 8px;
}

/deep/ .el-dialog__body {
    padding: 0px 20px 20px 20px !important;
}

/deep/ .el-form-item {
    margin-bottom: 12px !important;
}
</style>
